import Util from "./Util";

export default class Api {

  static async getMasterTicketData(){
    let masterData = sessionStorage.getItem(Util.SESSION_KEY_MASTER_AIRPLANE_TICKET);
    if(masterData){
      const tmpData = JSON.parse(masterData);
      const create_time = new Date(tmpData.create_time);
      const now = new Date();
      const today = new Date(now);
      today.setHours(0,0,0,0);

      const createdDay = new Date(create_time);
      createdDay.setHours(0,0,0,0);
      
      if(createdDay < today || (create_time.getHours() < 17 && now.getHours() >= 17)) masterData = null;
    }
    if(masterData){
      return JSON.parse(masterData);
    } else {
      try {
        const res = await fetch(LtikeCommon.API.HOTEL.TOP);
        const json = await res.json();
        json.create_time = new Date();
        Util.sessionStorageSetItem(Util.SESSION_KEY_MASTER_AIRPLANE_TICKET, JSON.stringify(json));
        return json;
      } catch (error) {
        throw error;
      }
    }
  }
}
